import React, { useState } from 'react';
import LoginPage from './pages/LoginPage';
import SubmissionPage from './pages/SubmissionPage';
import ConfirmationPage from './pages/ConfirmationPage';
import { getSession, clearSession } from './services/api';

const styles = {
  app: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #B04DAB 0%, #7B2D78 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    padding: '12px 24px',
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
  logo: {
    height: '40px',
    width: 'auto',
  },
  title: {
    color: '#9C3D97',
    fontSize: '18px',
    fontWeight: '600',
  },
  logoutBtn: {
    background: '#9C3D97',
    border: 'none',
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  content: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '40px 20px',
    width: '100%',
    maxWidth: '700px',
  },
};

export default function App() {
  const [page, setPage] = useState(getSession() ? 'submit' : 'login');
  const [confirmData, setConfirmData] = useState(null);

  const session = getSession();

  function handleLoginSuccess() {
    setPage('submit');
  }

  function handleSubmitSuccess(data) {
    setConfirmData(data);
    setPage('confirmation');
  }

  function handleSubmitAnother() {
    setConfirmData(null);
    setPage('submit');
  }

  function handleLogout() {
    clearSession();
    setPage('login');
  }

  return (
    <div style={styles.app}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <img src="/hellorache-logo.jpg" alt="HelloRache" style={styles.logo} />
          <span style={styles.title}>SOAP Note Submission Portal</span>
        </div>
        {session && (
          <button style={styles.logoutBtn} onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
      <div style={styles.content}>
        {page === 'login' && <LoginPage onSuccess={handleLoginSuccess} />}
        {page === 'submit' && <SubmissionPage onSuccess={handleSubmitSuccess} />}
        {page === 'confirmation' && (
          <ConfirmationPage data={confirmData} onSubmitAnother={handleSubmitAnother} />
        )}
      </div>
    </div>
  );
}
